import { z } from 'zod';
import { type ReleaseTestDocumentType, ReleaseTestDocumentType as RTDType, type ReleaseTestDocumentTypeFilter } from './-query/type';
const documentTypeValues = Object.values(RTDType) as [ReleaseTestDocumentType, ...ReleaseTestDocumentType[]];
export const ReleaseTestDocumentTypeFilterSchema = z.enum(['ALL', ...documentTypeValues]);

/**
 * ドキュメントタブのタイプフィルタタブ並び順:
 *   すべて / 内部向け / 外部向け
 */
export const RTD_TYPE_TABS = ['ALL', RTDType.FOR_INTERNAL, RTDType.FOR_EXTERNAL] as const satisfies readonly ReleaseTestDocumentTypeFilter[];
export function buildReleaseTestDocumentTabChangeSearch(tab: string) {
  const result = ReleaseTestDocumentTypeFilterSchema.safeParse(tab);
  return {
    type: result.success ? result.data : 'ALL' as const,
    pageIndex: 0,
    sortColumn: undefined,
    orderDirection: 'desc' as const
  };
}